import View from './Upsell';
import enhancer from './Upsell.enhancer';

const Upsell = enhancer(View);
export default Upsell;
